// Сбои JS без обработчика → событие js_error: window error (исключение) и unhandledrejection (отклонённый промис).
// Параметры: message — очищенный текст до 100 знаков, kind — error | rejection, screen — последний показанный экран.
// Из текста убираются данные запуска Telegram и ключи: у адресов остаются origin и путь (query и fragment несут
// tgWebAppData), вырезаются initData, hash=, tgWebAppData, Bearer-токены. Не больше 5 событий за сессию: цикл ошибок
// не забивает отчёты. Сбой самой аналитики (gtag.js, приёмник) события не порождает и приложение не роняет.
import { lastScreen, track } from './track';

export const JS_ERROR = 'js_error';
/** Предел событий js_error за сессию (открытие Mini App). */
export const JS_ERROR_LIMIT = 5;
const MESSAGE_MAX = 100;

const URL_RE = /\b[a-z][a-z0-9+.-]*:\/\/[^\s'"<>()]+/gi;
const SECRET_RES: [RegExp, string][] = [
  [/\bBearer\s+\S+/gi, 'Bearer [redacted]'],
  [/tgWebAppData\S*/gi, '[redacted]'],
  [/initData\S*/gi, '[redacted]'],
  [/\bhash=\S*/gi, '[redacted]'],
];

function stripUrl(raw: string): string {
  try {
    const u = new URL(raw);
    if (u.origin !== 'null') return u.origin + u.pathname;
  } catch { /* не адрес — режем руками */ }
  return raw.replace(/[?#].*$/, '');
}

/** Текст ошибки → безопасный для аналитики: адреса без query и fragment, без данных запуска и токенов, до 100 знаков. */
export function cleanMessage(raw: string): string {
  let s = raw.replace(URL_RE, stripUrl);
  for (const [re, to] of SECRET_RES) s = s.replace(re, to);
  s = s.replace(/\s+/g, ' ').trim();
  return s.slice(0, MESSAGE_MAX) || 'unknown';
}

function describe(value: unknown): string {
  if (value instanceof Error) return value.message ? `${value.name}: ${value.message}` : value.name;
  if (typeof value === 'string') return value;
  if (value && typeof value === 'object' && typeof (value as { message?: unknown }).message === 'string') {
    return (value as { message: string }).message;
  }
  return value === undefined ? '' : typeof value;
}

/** Ошибка из скрипта аналитики (gtag.js) — не наша: её не шлём, иначе сбой приёмника кормит сам себя. */
const ANALYTICS_SRC = /googletagmanager\.com|google-analytics\.com/i;
const fromAnalytics = (...texts: (string | undefined)[]) => texts.some((t) => !!t && ANALYTICS_SRC.test(t));

let sent = 0;
let busy = false;

function report(kind: 'error' | 'rejection', raw: string, source?: string, stack?: string): void {
  // повторный вход — ошибка родилась внутри отправки (приёмник): события нет
  if (busy || sent >= JS_ERROR_LIMIT || fromAnalytics(source, stack)) return;
  busy = true;
  try {
    sent++;
    track(JS_ERROR, { message: cleanMessage(raw), kind, screen: lastScreen() });
  } catch { /* аналитика не роняет приложение */ } finally { busy = false; }
}

function onError(e: ErrorEvent): void {
  try {
    const err: unknown = e.error;
    const raw = e.message || describe(err);
    report('error', raw, e.filename, err instanceof Error ? err.stack : undefined);
  } catch { /* аналитика не роняет приложение */ }
}

function onRejection(e: PromiseRejectionEvent): void {
  try {
    const reason: unknown = e.reason;
    report('rejection', describe(reason), undefined, reason instanceof Error ? reason.stack : undefined);
  } catch { /* аналитика не роняет приложение */ }
}

/** Подписка на ошибки окна — до рендера (main.tsx). Повторный вызов не дублирует подписку. Возвращает отписку. */
export function installGlobalErrors(target: Window = window): () => void {
  target.removeEventListener('error', onError);
  target.removeEventListener('unhandledrejection', onRejection);
  target.addEventListener('error', onError);
  target.addEventListener('unhandledrejection', onRejection);
  return () => {
    target.removeEventListener('error', onError);
    target.removeEventListener('unhandledrejection', onRejection);
  };
}

/** Тесты: новая сессия — счётчик предела с нуля. */
export function resetGlobalErrorsForTest(): void { sent = 0; busy = false; }
